import { useQuery } from "@tanstack/react-query";
import { callAnalyticsApi } from "./api";
import { ImprovementsTab } from "./improvements";

export function PromptInsightsPage() {
  const config = useQuery({ queryKey: ["call-analytics", "config"], queryFn: callAnalyticsApi.config });

  return (
    <div className="space-y-4 px-4 pb-6 pt-3 sm:px-5 sm:pt-4 md:px-6">
      <header className="flex items-center justify-between gap-3">
        <h1 className="text-sm font-semibold text-ink">Prompt Insights</h1>
      </header>

      {config.data && !config.data.master_enabled ? (
        <p role="status" className="rounded-xl border border-line bg-soft px-3 py-2 text-sm text-ink-2">
          Call Analytics is not enabled for your organization, so no new calls are analysed. TechLadder turns it on.
        </p>
      ) : null}

      <ImprovementsTab />
    </div>
  );
}
